import { endpoint } from '@chilipiper/config'
import { useTenantDetails } from '../api/tenant'

export const useAdminCenterUrl = () => {
  const { data: tenantDetails } = useTenantDetails()

  return tenantDetails
    ? `${endpoint.fire().replace('fire', tenantDetails.tenantInfo.tenantData.subdomain)}${
        // eslint-disable-next-line no-process-env
        process.env.REACT_APP_FIRE_ADMIN_PATH
      }`
    : undefined
}
